import React from 'react';
import ServicePageTemplate from '../../components/ServicePageTemplate';
import { PenTool } from 'lucide-react';
import { servicePricing } from '../../mockData';

const CreativeCopywriting = () => {
  const features = [
    {
      title: "Website Copy",
      description: "Compelling homepage, about us, and landing page content"
    },
    {
      title: "Blog Content",
      description: "SEO-optimized articles that engage readers and rank in search"
    },
    {
      title: "Ad Copy",
      description: "High-converting copy for Google Ads, Facebook Ads, and more"
    },
    {
      title: "Email Campaigns",
      description: "Persuasive email sequences that nurture leads and drive sales"
    },
    {
      title: "Product Descriptions",
      description: "Engaging descriptions that highlight benefits and convert browsers"
    },
    {
      title: "Brand Messaging",
      description: "Develop your unique voice and messaging framework"
    }
  ];

  const benefits = [
    {
      title: "Professional Voice",
      description: "Communicate your value clearly and professionally to build trust"
    },
    {
      title: "Better Conversions",
      description: "Persuasive copy that turns visitors into customers"
    },
    {
      title: "Save Time",
      description: "Focus on your business while we handle all your content needs"
    },
    {
      title: "Consistent Brand",
      description: "Maintain a consistent voice across all marketing channels"
    }
  ];

  const process = [
    {
      title: "Brand Discovery",
      description: "Understand your brand, audience, and unique value proposition"
    },
    {
      title: "Content Strategy",
      description: "Plan content that aligns with your goals and resonates with audience"
    },
    {
      title: "Writing & Refinement",
      description: "Create compelling copy and refine based on your feedback"
    },
    {
      title: "Delivery & Support",
      description: "Deliver final content and provide ongoing copywriting support"
    }
  ];

  const copywritingPricing = [
    {
      id: 1,
      name: "Essential Copy",
      price: "$1,500",
      period: "per project",
      description: "Core website content",
      features: [
        "5-page website copy",
        "Homepage",
        "About Us",
        "Services page",
        "Contact page",
        "2 revision rounds"
      ],
      color: "#b7fbff",
      popular: false
    },
    {
      id: 2,
      name: "Content Package",
      price: "$4,500",
      period: "per project",
      description: "Complete content suite",
      features: [
        "10-page website copy",
        "4 blog articles (1,000+ words)",
        "Email sequence (5 emails)",
        "Social media content",
        "Brand messaging guide",
        "Unlimited revisions"
      ],
      color: "#d987ff",
      popular: true
    },
    {
      id: 3,
      name: "Ongoing Content",
      price: "$2,500/mo",
      period: "monthly",
      description: "Continuous content creation",
      features: [
        "8 blog articles per month",
        "Weekly social media posts",
        "Email campaigns",
        "Ad copy as needed",
        "SEO optimization",
        "Content strategy consulting"
      ],
      color: "#88a2ff",
      popular: false
    }
  ];

  return (
    <ServicePageTemplate
      title="Creative Copywriting"
      subtitle="Words That Convert"
      description="Compelling content that tells your brand story and drives action. From website copy to blog articles, we create content that resonates with your audience and boosts conversions."
      features={features}
      benefits={benefits}
      pricing={copywritingPricing}
      icon={PenTool}
      bgColor="#b7fbff"
      process={process}
    />
  );
};

export default CreativeCopywriting;